export default function syncSkinnyBannerLayout(swiper, hasSkinnyBanner) {
  const element = swiper?.el
  if (!element) return undefined

  const updateLayout = () => {
    if (!swiper.destroyed) swiper.update?.()
  }
  const onHeightTransitionEnd = (event) => {
    if (event.target === element && event.propertyName === 'height') {
      updateLayout()
    }
  }

  // Both appearance and removal change the slide viewport. Recalculate again
  // after its CSS height transition so Swiper does not keep the previous size.
  element.addEventListener('transitionend', onHeightTransitionEnd)
  element.classList.toggle(
    'carousel__swiper-container__with-skinny-banner',
    Boolean(hasSkinnyBanner),
  )
  updateLayout()

  return () => {
    element.removeEventListener('transitionend', onHeightTransitionEnd)
  }
}
